import React from 'react';
import "./RaikoCustomEditorStyleSheet.scss"

export class RaikoCustomEditorUtils {

    editorItemType = {
        "HTML": "HTML",
        "TEXT": "TEXT",
        "IMAGE_SLIDER": "IMAGE_SLIDER",
        "IMAGE": "IMAGE",
    }

    editorItemsList = [
        {
            title: "اسلایدر",
            icon: "sliderIcon-icon",
            type: this.editorItemType.IMAGE_SLIDER
        }, {
            title: "تصویر",
            icon: "pictureIcon-icon",
            type: this.editorItemType.IMAGE
        }, {
            title: "متن",
            icon: "textEditorIcon-icon",
            type: this.editorItemType.HTML
        },
    ]


    insertInterface = (position, editorData, setEditorData, isBefore = false) => {
        return (<section className="insertItemInterfaceContainer">

            {this.editorItemsList.map((item, index) => {
                return <div
                    className={`editorIcon ${item.icon}`}
                    key={index}
                    onClick={_ => {
                        this.doInsert(editorData, position, isBefore, setEditorData, item.type);
                    }}
                />

            })}

            <div className={`bottom_arrow-icon`}/>

        </section>)
    }

    doInsert(editorData, position, isBefore, setEditorData, type) {
        if (typeof editorData !== 'undefined' && typeof position !== 'undefined') {
            if (isBefore)
                this.insertTextEditorBefore(editorData, position, setEditorData, type)
            else
                this.insertTextEditorAfter(editorData, position, setEditorData, type)
        }
    }

    insertTextEditorBefore(editorData, position, setEditorData, editorType) {
        const _editorData = []

        if (editorData.length > 0)
            editorData.map((item, index) => {
                if (index === position) {
                    _editorData.push(this.getTextEditorItem(editorType))
                    _editorData.push(item)
                } else
                    _editorData.push(item)
            })
        else
            _editorData.push(this.getTextEditorItem(editorType))

        setEditorData([])

        setEditorData(_editorData)
    }

    insertTextEditorAfter(editorData, position, setEditorData, editorType) {
        const _editorData = []

        if (editorData.length > 0)
            editorData.map((item, index) => {
                if (index === position) {
                    _editorData.push(item)
                    _editorData.push(this.getTextEditorItem(editorType))
                } else
                    _editorData.push(item)
            })
        else
            _editorData.push(this.getTextEditorItem(editorType))

        setEditorData([])

        setEditorData(_editorData)
    }

    getTextEditorItem(editorType) {
        switch (editorType) {
            case this.editorItemType.HTML:
                return {
                    content: {
                        type: editorType,
                        amount: ""
                    }
                }
            case this.editorItemType.IMAGE:
                return {
                    content: {
                        type: editorType,
                        amount: ""
                    }
                }
            case this.editorItemType.IMAGE_SLIDER:
                return {
                    content: {
                        type: editorType,
                        amount: []
                    }
                }
            default:
                return {}

        }
    }


    deleteInterface = (position, editorData, setEditorData) => {
        return (<section className="deleteItemInterfaceContainer">

            <div
                className={`editorIcon trash-icon`}
                onClick={_ => {
                    if (typeof editorData !== 'undefined' && typeof position !== 'undefined') {
                        this.deleteItem(editorData, position, setEditorData);
                    }
                }}
            />

        </section>)
    }

    deleteItem(editorData, position, setEditorData) {
        const _editorData = []
        editorData.map((item, index) => {
            if (index !== position) {
                _editorData.push(item)
            }
        })
        setEditorData([])
        setEditorData(_editorData)
    }


}


export function prepareBlogDescriptionForSaveToServer(description) {
    const _description = []
    description.map((item, index) => {

        _description.push(
            {
                "content": {
                    type: item.content.type,
                    amount: item.content.amount
                },
                "priority": index
            }
        )
    })

    return _description
}
